'use client';

import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '../../lib/cn';

export interface TabItem {
  value: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
}

export interface TabsProps {
  tabs: TabItem[];
  value?: string;
  defaultValue?: string;
  onValueChange?: (value: string) => void;
  className?: string;
  'aria-label'?: string;
}

/** Underline tab bar. Active tab shows an accent underline + primary text. */
export function Tabs({ tabs, value, defaultValue, onValueChange, className, ...aria }: TabsProps) {
  return (
    <TabsPrimitive.Root
      value={value}
      defaultValue={defaultValue ?? tabs[0]?.value}
      onValueChange={onValueChange}
    >
      <TabsPrimitive.List className={cn('flex gap-1 border-b border-border', className)} {...aria}>
        {tabs.map((t) => (
          <TabsPrimitive.Trigger
            key={t.value}
            value={t.value}
            className={cn(
              'relative -mb-px inline-flex cursor-pointer items-center gap-[var(--space-1-5)] border-b-2 border-transparent',
              'px-3 py-[var(--space-2-5)] font-sans text-base font-medium text-fg-muted outline-none',
              'transition-colors duration-[var(--duration-fast)]',
              'hover:text-fg-secondary data-[state=active]:border-accent data-[state=active]:font-semibold data-[state=active]:text-fg',
            )}
          >
            {t.icon}
            {t.label}
          </TabsPrimitive.Trigger>
        ))}
      </TabsPrimitive.List>
    </TabsPrimitive.Root>
  );
}
